// Return-to-page after login/sign-up. Only same-site paths are allowed, so a
// crafted ?next= link can't send a student off to another website.
export const safeNextPath = (next?: string | null): string | null => {
  if (
    !next ||
    !next.startsWith('/') ||
    next.startsWith('//') ||
    next.startsWith('/\\') ||
    next.includes('://') ||
    next.startsWith('/login') ||
    next.startsWith('/register')
  ) {
    return null
  }
  return next
}

// Current page as a ?next= value, for sending a logged-out visitor to login.
export const currentPathForNext = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }
  return safeNextPath(
    window.location.pathname + window.location.search + window.location.hash,
  )
}
